export default function NoIcon() {
  return (
    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.93773 2.99902C3.93773 3.93099 3.18221 4.68651 2.25024 4.68651C1.31826 4.68651 0.562745 3.93099 0.562745 2.99902C0.562745 2.06704 1.31826 1.31152 2.25024 1.31152C3.18221 1.31152 3.93773 2.06704 3.93773 2.99902Z"
        fill="url(#paint0_linear_2406_2364)"
        stroke="url(#paint1_linear_2406_2364)"
        stroke-width="0.374998"
      />
      <circle cx="2.25024" cy="2.99902" r="1.49999" fill="url(#paint2_linear_2406_2364)" />
      <g style={{ mixBlendMode: 'screen' }}>
        <circle cx="2.62524" cy="2.62401" r="1.87499" fill="url(#paint3_radial_2406_2364)" />
      </g>
      <g style={{ mixBlendMode: 'screen' }}>
        <ellipse
          cx="2.42222"
          cy="2.38987"
          rx="2.42222"
          ry="2.38987"
          transform="matrix(0.92755 0.373699 -0.512527 0.858671 1.87231 0.388916)"
          fill="url(#paint4_radial_2406_2364)"
        />
      </g>
      <g style={{ mixBlendMode: 'screen' }}>
        <ellipse
          cx="1.61407"
          cy="1.95694"
          rx="1.61407"
          ry="1.95694"
          transform="matrix(0.92755 0.373699 -0.512527 0.858671 2.0061 0.749023)"
          fill="url(#paint5_radial_2406_2364)"
        />
      </g>
      <defs>
        <linearGradient id="paint0_linear_2406_2364" x1="0.881493" y1="1.72938" x2="3.25938" y2="4.17235" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FE5B27" />
          <stop offset="1" stop-color="#C64219" />
        </linearGradient>
        <linearGradient id="paint1_linear_2406_2364" x1="1.00024" y1="2.12402" x2="2.83334" y2="4.71117" gradientUnits="userSpaceOnUse">
          <stop stop-color="#F98A67" />
          <stop offset="1" stop-color="#F98A67" stop-opacity="0.15" />
        </linearGradient>
        <linearGradient id="paint2_linear_2406_2364" x1="0.9806" y1="1.63027" x2="3.42357" y2="4.00816" gradientUnits="userSpaceOnUse">
          <stop offset="0.01" stop-color="#C64219" />
          <stop offset="0.995" stop-color="#FE5B27" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_2406_2364"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.66988 3.28717) rotate(92.1098) scale(1.21266 1.2149)"
        >
          <stop stop-color="#F76431" />
          <stop offset="1" stop-color="#F76431" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_2406_2364"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.42222 2.38987) rotate(90) scale(2.38987 2.42222)"
        >
          <stop stop-color="#FF5B27" />
          <stop offset="1" stop-color="#FF5B27" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_2406_2364"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.61407 1.95694) rotate(90) scale(1.95694 1.61407)"
        >
          <stop stop-color="#F5A65D" />
          <stop offset="1" stop-color="#F5A65D" stop-opacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
}
